export const EMPTY_ADDRESS = {
	street: '',
	street_line_two: '',
	city: '',
	state: '',
	zipcode: '',
	latitude: undefined,
	longitude: undefined,
};

export const ADDRESS_FIELD_NAMES = ['street', 'street_line_two', 'city', 'state', 'zipcode', 'latitude', 'longitude'];

export const REQUIRED_ADDRESS_FIELDS = ['street', 'city', 'state', 'zipcode'];
